<template>
  <div class="main-container">
    <canvas id="canvasRender" style="z-index: 100"></canvas>
    <div v-if="showCard" class="mask" @click="showCard = false"> </div>
    <div v-if="!clearScreen" class="top" :style="showCard ? 'bottom: 82vh;' : 'bottom: 42vh'">
      <button v-if="!showCard" class="top-btn unfold-btn" @click="onUnfoldClick"> </button>
      <button v-if="showCard" class="top-btn fold-btn" @click="onFoldClick"> </button>
    </div>

    <div v-if="!clearScreen" class="bottom-card" :style="showCard ? 'bottom: 0;' : 'bottom: -40vh;'">
      <div class="tip-container">
        <div class="note">
          <div class="color-card">
            <div style="white-space: nowrap;padding: 0 6px;">噪音(Db):</div>
              <div class="color-content" :style="gradientBarStyle">
                <div style="margin: 0 6px;">极静</div>
                <div style="margin: 0 6px;">极吵</div>
              </div>
            <div class="question" @click="showInstruction">
              <img style="width:24px;height:24px" src="/images/question.png">
            </div>
          </div>
        </div>
      </div>
      <div class="building-box">
        <button class="allBuilding-btn" @click="changeIsDay">查看{{isDay ? '晚上' : '白天'}}</button>
        <div class="buildNumber-terms" id='nav'>
          <van-button class="btn" :class="{ active: selectBuildNumber === item }" plain type="default"
            v-for="(item, index) in buildNumbers" :key="index" :id="'button-' + index"
            @click="choseBuildNumber(item)">{{
              item + ' #' }}</van-button>
        </div>
      </div>
      <div class="table-container">
        <table class="floor-unit-table" v-if="noiseData.find(item => item.buildingNumber === tableBuildNumber)">
          <thead class="header">
            <tr>
              <th style="width: 32px; max-width: 40px; min-width: 20px;"></th>
              <th :colspan="getRoomsByUnit(tableBuildNumber, unit)" v-for="unit in units" :key="unit"> {{ unit }} 单元</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="floor in visibleFloors" :key="floor">
              <td style="font-size: 14px;">{{ floor }}层</td>
              <td style="border: 1px solid #f8fafd;" v-for="(item, index) in getRoomsByAFloor(units)" :key="index">
                <!-- 单元层数可以各不相同：这一层对该单元不存在时，格子不显示噪声值 -->
                <a-popover trigger="click" v-if="floor <= getHouseTotalFloor(item.unit, item.room)">
                  <template #content>
                    <div v-for="d in getNoiseDataDetail(tableBuildNumber, floor, item.unit, item.room)" :key="d">
                      {{ d.southWallName }}<br>
                      白天 <span style="color: #FAAD14;">{{ d.dayNoise.toFixed(2) }}</span> dB<br>
                      晚上 <span style="color: #FAAD14;">{{ d.nightNoise.toFixed(2) }}</span> dB<br>
                    </div>
                  </template>
                  <div class="table-cell" :style="getTableCellStyle(getNoiseTableData(tableBuildNumber, floor, item.unit, item.room,isDay))">
                    {{ getHouseNumber(floor, item.room) }} <br>
                    <span :class="isDay ? 'field-data-active':'field-data'">
                      白天 {{ getNoiseTableData(tableBuildNumber, floor, item.unit, item.room,true) }} dB
                    </span>
                    <br>
                    <span :class="isDay ? 'field-data':'field-data-active'">
                      晚上 {{ getNoiseTableData(tableBuildNumber, floor, item.unit, item.room,false) }} dB
                    </span>
                  </div>
                </a-popover>
              </td>
            </tr>
          </tbody>
        </table>
        {{ noiseData.find(item => item.buildingNumber === tableBuildNumber) ? '' : '暂无噪音数据' }}
        <div class="tip-container">
          <p class="disclaimer">
            噪音分析免责声明：<br>
            噪音数据系依据政府规划公示图纸等第三方资料，经专业建模模拟评测得出。
            请注意，该数据仅将道路作为噪声源，噪声影响因素较多，在模拟评测时仅考虑了噪声衰减及建模建筑的遮挡因素，数据存在一定误差，仅供参考，不应单独作为交易决策的依据。
            针对具体房源的噪音信息及准确性，请务必与开发商核实，并以开发商提供的信息为准。
            鉴于施工规划变更、图纸精度等因素，本噪音结果可能与实际情况存在偏差，数据仅供参考。
          </p>
        </div>
      </div>
    </div>
    <div class="clear-screen-btn" @click="clearScreen ? clearScreen = false : clearScreen = true">
      {{ clearScreen ? '显示' : '清屏' }}
    </div>
    <NoiseInstruction 
      ref="noiseInstruction" 
      :showModal="instructionVisible"
      @closeModal="closeInstructionModal"
    />
  </div>
  
</template>
<script>
import {
  getCommunityDetail,
  isMember,
  getResidentialByCode,
  getRoadByCode,
  getNoiseByCode,
  checkPageAccess,
  checkPwd
} from '@/utils/api'
import NoiseViewOpen  from './NoiseAnalysisThree'
import { getCustomColors } from '@/utils/colorThemeApi'
import { Modal } from 'ant-design-vue';
import { h } from 'vue';
import NoiseInstruction from './NoiseInstruction.vue';
import { getHouseFloorsByUnitRoom } from '@/utils/floors';

let noiseView = null;

export default {
  components: {
    NoiseInstruction
  },
  data() {
    return {
      buildNumbers: [],
      noiseDataMap: new Map(),
      noiseData: [],
      showCard: false,
      houseRoomMap: new Map(),
      isDay: true,
      tableBuildNumber: '',
      units: 0,
      totalFloor: 0,
      selectBuildNumber: '',
      residentialName: '',
      residenceData: [],
      selectCellKey: '',
      colorCard: [
        { text: '0', color: '#feefe7' },
        { text: '20', color: '#fde0cf' },
        { text: '30', color: '#fcd0b7' },
        { text: '40', color: '#fbc1a0' },
        { text: '50', color: '#fab188' },
        { text: '60', color: '#f9a270' },
        { text: '70', color: '#f89258' },
        { text: '80', color: '#f78341' },
        { text: '90', color: '#f67328' },
        { text: '>90', color: '#f56411' },
      ],
      clearScreen: false,
      instructionVisible: false,
      customColors: [],
    }
  },
  computed: {
    gradientBarStyle() {
      const colors = this.customColors.length ? this.customColors : this.colorCard.map(c => c.color)
      const stops = colors.map((c, i) => `${c} ${(i / (colors.length - 1) * 100).toFixed(1)}%`).join(', ')
      return { background: `linear-gradient(90deg, ${stops})` }
    },
    // 按当前楼栋实际存在的楼层生成行，层数不足的单元不会在多出来的楼层出现空格子
    visibleFloors() {
      const rooms = this.getRoomsByAFloor(this.units)
      const floors = []
      for (let floor = this.totalFloor; floor >= 1; floor--) {
        if (rooms.some(item => floor <= this.getHouseTotalFloor(item.unit, item.room))) {
          floors.push(floor)
        }
      }
      return floors
    }
  },
  mounted() {
    getCustomColors(3).then(colors => {
      this.customColors = colors
      if (noiseView) noiseView.setCustomColors(colors)
    })
  },
  created() {
    checkPageAccess(this.$route.params.code, 6).then((res) => {
      if (res.data.code === 200) {
        this.initPage(res.data.result);
      } else {
        if(res.data.result){
          this.needPassword = true;
          this.showPasswordModal(res.data.result);
        }else{
          Modal.error({
            title: '提示',
            content: res.data.message || '检查页面访问权限失败',
          });
        }
      }
    }).catch((error) => {
      console.error('网络请求出错', error);
      Modal.error({
        title: '提示',
        content: '网络请求出错，请稍后重试',
      })
    })
  },
  methods: {
    initPage(code){
      document.title = "3D楼盘建模大师";
      getResidentialByCode(code).then((res) => {
        if (res.data.code == 200) {
          this.residentialName = res.data.result.residentialName;
        }
      })
      isMember(code).then((res) => {
        if(res.data.result != null && res.data.result.businessMemberType === 3){
          document.title = this.residentialName;
          getCommunityDetail(code).then((res) => {
            let minBaseHeight = 0;
            if (res.data.code == 200) {
              let result = res.data.result;
              result.barrierReqList.forEach(element => {
                if (element.houseList.length > 0) {
                  this.buildNumbers.push(element.buildingNumber);
                }
                if(element.baseHeight < minBaseHeight || minBaseHeight === 0){
                  minBaseHeight = element.baseHeight;
                }
                this.residenceData.push({
                  buildingNumber: element.buildingNumber,
                  units: element.units,
                  totalFloor: element.totalFloor
                })
              });
              // 对 buildNumbers 进行排序
              this.buildNumbers.sort((a, b) => {
                const isANumber = !isNaN(parseFloat(a)) && isFinite(a);
                const isBNumber = !isNaN(parseFloat(b)) && isFinite(b);
                if (isANumber && isBNumber) {
                  return parseFloat(a) - parseFloat(b);
                } else if (isANumber) {
                  return -1;
                } else if (isBNumber) {
                  return 1;
                }
                return a.localeCompare(b);
              });
              this.tableBuildNumber = this.buildNumbers[0];
              this.selectBuildNumber = this.buildNumbers[0];
              getRoadByCode(code).then((res) => {
                if (res.data.code == 200) {
                  result.roadList = res.data.result;
                }
                noiseView = new NoiseViewOpen({
                  element: document.querySelector("#canvasRender"),
                  history: result,
                  onChoseBuildNumber: this.onChoseBuildNumber,
                  minBaseHeight: minBaseHeight
                });
                noiseView.init();
                noiseView.setCustomColors(this.customColors);
                this.initNoise(code, result);
              })
            } else {
              Modal.error({
                title: '提示',
                content: res.data.message || '请求失败',
              })
            }
          })
        }else {
          Modal.error({
            title: '提示',
            content: '当前账号未开通会员服务，该页面暂停访问',
          })
        }
      })
    },

    initNoise (code, result) {
      getNoiseByCode(code).then((res) => {
        if (res.data.code == 200) {
          res.data.result.forEach(element => {
            let key = element.buildingNumber + '_' + element.unit + '_' + element.floorNumber + '_' + Number(element.room);
            if(this.noiseDataMap.has(key) == false){
              this.noiseDataMap.set(key, {
                dayNoise: element.dayNoise,
                nightNoise: element.nightNoise,
                buildingNumber: element.buildingNumber,
                unit: element.unit,
                floorNumber: element.floorNumber,
                room: Number(element.room),
                modelKey: element.buildingNumber + '_' + element.unit + '_' + element.floorNumber + '_' + element.room,
                wallCount: 1,
                list: [{southWallName:element.southWallName, dayNoise: element.dayNoise, nightNoise: element.nightNoise}]
              });
            } else {
              let value = this.noiseDataMap.get(key);
              value.dayNoise += element.dayNoise;
              value.nightNoise += element.nightNoise;
              value.wallCount += 1;
              value.list.push({southWallName:element.southWallName, dayNoise: element.dayNoise, nightNoise: element.nightNoise})
              this.noiseDataMap.set(key, value);
            }
          });
          this.noiseData = Array.from(this.noiseDataMap.values());
          this.noiseDataFormat(this.noiseData);
          this.residenceData = result.barrierReqList;
          console.log(this.residenceData)
          this.units = this.residenceData.find(item => item.buildingNumber === this.tableBuildNumber).units;
          this.totalFloor = this.residenceData.find(item => item.buildingNumber === this.tableBuildNumber).totalFloor;
          this.initNoiseColor();
          }
      })
    },
    showPasswordModal(id){
      Modal.confirm({
        title: '请输入密码',
        content: h('input', {
          style: 'border: 1px solid #ccc; border-radius: 4px;',
          type: 'password',
          value: this.password,
          placeholder: '请输入访问密码',
          onInput: (e) => this.password = e.target.value
        }),
        okText: '确认',
        cancelText: '取消',
        onOk: () => this.checkPassword(id),
        onCancel: () => {}
      });
    },
    checkPassword (id) {
      checkPwd(id, this.password).then((res) => {
        if (res.data.code === 200) {
          this.initPage(res.data.result);
          this.needPassword = false;
        } else {
          Modal.error({
            title: '提示',
            content: res.data.message || '密码错误，请重新输入',
            okText: '重新输入',
            onOk: () => {
              this.password = ''; // 清空密码输入框内容
              this.showPasswordModal(id); // 重新打开密码输入框
            }
          });
        }
      })
    },
    initNoiseColor(){
      if(!noiseView) return;
      this.noiseDataMap.forEach((value) => {
        let noise = (this.isDay ? value.dayNoise : value.nightNoise) / value.wallCount;
        let mesh = noiseView.roomMeshMap.get(value.modelKey)
        if(mesh == null) return;
        noiseView.updateRoomColor(mesh,noise)
      })
    },
    onUnfoldClick() {
      this.showCard = true;
    },
    onFoldClick() {
      this.showCard = false;
    },
    choseBuildNumber(number) {
      noiseView.switchHighlightBuilding(number)
    },
    onChoseBuildNumber(number) {
      number = decodeURIComponent(number).replace('%2D', '-');
      this.selectBuildNumber = number;
      this.tableBuildNumber = number;

      this.units = this.residenceData.find(item => item.buildingNumber === this.tableBuildNumber).units;
      this.totalFloor = this.residenceData.find(item => item.buildingNumber === this.tableBuildNumber).totalFloor;
    },
    noiseDataFormat(noiseDataList) {
      noiseDataList.forEach(noiseData => {
        let room = Number(noiseData.room);
        if (room < 10) {
          room = "0" + room;
        }
        let key = noiseData.buildingNumber + noiseData.unit;
        let roomArr = [];
        if (this.houseRoomMap.has(key)) {
          roomArr = this.houseRoomMap.get(key);
        }
        if (!roomArr.includes(Number(noiseData.room))) {
          roomArr.push(Number(noiseData.room));
          this.houseRoomMap.set(key, roomArr);
        }
      });
      for (let [key, value] of this.houseRoomMap) {
        value.sort((a, b) => a - b);
        this.houseRoomMap.set(key, value);
      }
    },
    onAllBuildingClick() {
      noiseView.switchHighlightBuilding();
    },
    getRoomsByUnit(building, unit) {
      let key = building + unit;
      let roomArr = this.houseRoomMap.get(key);
      if (roomArr == null) {
        return 0;
      }
      return roomArr.length;
    },
    getRoomsByAFloor(units) {
      let rooms = [];
      for (let i = 0; i < units; i++) {
        let key = this.tableBuildNumber + (i + 1);
        let roomArr = this.houseRoomMap.get(key);
        if (roomArr) {
          roomArr.forEach(room => {
            rooms.push({
              'unit': i + 1,
              'room': room
            });
          });
        }
      }
      return rooms;
    },
    getHouseNumber(floor, room) {
      if (room < 10) {
        room = "0" + room;
      }
      return floor + room;
    },
    getTableCellStyle(value) {
      const c = this.customColors
      const defaults = ['#feefe7', '#fde0cf', '#fcd0b7', '#fbc1a0', '#fab188', '#f9a270', '#f89258', '#f78341', '#f67328', '#f56411']
      const resolve = (i) => (c.length > i && c[i]) ? c[i] : defaults[i]
      let background, index;
      if (value > 90) { index = 9 }
      else if (value > 80) { index = 8 }
      else if (value > 70) { index = 7 }
      else if (value > 60) { index = 6 }
      else if (value > 50) { index = 5 }
      else if (value > 40) { index = 4 }
      else if (value > 30) { index = 3 }
      else if (value > 20) { index = 2 }
      else if (value > 0)  { index = 1 }
      else { index = 0 }
      background = resolve(index)
      let color = index > 4 ? '#ffffff' : '#242424';
      return `background-color: ${background}; color: ${color};`;
    },
    // 该单元本层是否存在噪声数据；沿用楼栋层数的单元没填 totalFloor，回退用楼栋层数
    getHouseTotalFloor(unit, room) {
      const building = this.residenceData.find(item => item.buildingNumber === this.tableBuildNumber)
      return building ? getHouseFloorsByUnitRoom(building, unit, room) : this.totalFloor
    },
    getNoiseTableData(tableBuildNumber, floor, unit, room, isDay) {
      let key = tableBuildNumber + "_"
        + unit + "_"
        + floor + "_"
        + room;
      let data = this.noiseDataMap.get(key);
      // 理论上 visibleFloors/v-if 已经挡掉了不存在的楼层，这里仍判空兜底，避免数据没跑批时崩掉
      if (!data) return ''
      return ((isDay ? data.dayNoise : data.nightNoise) / data.wallCount).toFixed(2);
    },
    getNoiseDataDetail(tableBuildNumber, floor, unit, room) {
      let key = tableBuildNumber + "_"
        + unit + "_"
        + floor + "_"
        + room;
      const data = this.noiseDataMap.get(key);
      return data ? data.list : []
    },
    changeIsDay() {
      this.isDay = !this.isDay;
      this.initNoiseColor();
      noiseView.switchDayOrNight(this.isDay);
    },
    showInstruction() {
      this.instructionVisible = !this.instructionVisible;

    },
    closeInstructionModal() {
      this.instructionVisible = false;
    }

  }
}
</script>
<style scoped lang="scss">
.main-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.canvas-view {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 88;
}
.bottom-card {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  max-width: 800px;
  width: 90vw;
  height: calc(80vh - 24px);
  border-radius: 8px 8px 0 0;
  padding: 12px 10px 24px;

  display: flex;
  flex-flow: column nowrap;
  gap: 8px;
  background: rgba(255, 255, 255, 1);
  z-index: 888;
}

.building-box {
  width: 100%;
  min-height: fit-content;
  display: flex;
  flex-flow: row nowrap;
  margin: 10px 0;
  margin-top: 0;
  .allBuilding-btn {
    width: auto;
    height: 24px;
    white-space: nowrap;
    font-size: 14px;
    border: none;
    background: transparent;
    position: relative;
    color: #1890FF;
  }

  .allBuilding-btn::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 88%;
    background: linear-gradient(to top, #f8fafd, #f3f5fb, #f8fafd);
    pointer-events: none;
    /* 使伪元素不干扰按钮的点击事件 */
  }
}
.buildNumber-terms {
  min-height: fit-content;
  white-space: nowrap;
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  gap: 8px;

  .btn {
    min-width: 60px;
    width: 12vw;
    height: 24px;
    white-space: nowrap;
    font-size: 14px;
    border: none;

    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    box-sizing: border-box;
    background: transparent;
  }

  .active {
    position: relative;
  }

  .active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 50%;
    height: 8px;
    /* 边框厚度 */
    background: linear-gradient(to right, rgba(245, 170, 70, 0.8), rgba(245, 170, 70, 0));
    /* 渐变色 */
    border-radius: 8px;
    /* 圆角处理 */
    z-index: -1;
    /* 确保边框在内容下方 */
  }
}

  .table-container {
    width: 100%;
    min-height: 60px;
    max-height: 100%;
    overflow-y: auto;

    .floor-unit-table {
      width: 100%;
      background-color: #f8fafd;
      border-collapse: collapse; /* 去除表格的默认间距 */

      .header {
        position: sticky;
        /* 固定表头在容器顶部 */
        top: 0;
        background-color: #f3f5fb;
        font-size: 14px;
        z-index: 2;
      }

      .header th {
        padding: 8px;
      }

      .table-cell {
        min-width: 110px;
        padding: 6px;
        position: relative;
        font-size: 12px;
      }

      .field-data {
          font-size: 14px;
      }
      .field-data-active {
          font-weight: bolder;
          font-size: 15px;
      }
    }
  }

.top {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  max-width: 800px;
  width: 90vw;
  height: 28px;

  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.88);
  text-shadow: 1px 1px 1px rgba(8, 8, 8, 0.8);
  z-index: 888;

  .value {
    color: rgb(245, 170, 70);
    text-shadow: 1px 1px 1px rgba(245, 100, 17, 0.8);
  }

  .top-btn {
    width: 20vw;
    border: none;
    outline: none;
    box-shadow: none;
    background: transparent;
    background-size: 28px;
    background-position: center;
    /* 将背景图居中 */
    background-repeat: no-repeat;
    /* 防止背景图重复 */
    opacity: 0.8;
    /* 设置按钮整体的透明度 */
    filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.8));
    /* 添加阴影 */
    cursor: pointer;
  }

  .unfold-btn {
    background-image: url('/public/images/unfold.png');
    /* 文字上下浮动 */
    animation: float 1s infinite alternate;
  }

  @keyframes float {
    0% {
      transform: translateY(0);
    }

    100% {
      transform: translateY(-5px);
    }
  }

  .fold-btn {
    background-image: url('/public/images/fold.png');
  }
}

.tip-container {
  width: 100%;
  height: auto;
  min-height: fit-content;
  margin: 0 0 10px 0;
  display: flex;
  flex-flow: column nowrap;
  gap: 8px;
  color: #888888;
  .note {
    font-size: 12px;
    text-align: left;

    display: flex;
    flex-flow: column nowrap;

    .color-card {
      width: 100%;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;

      .question {
        width: 24px;
        height: 24px;
        margin-left: 3px;
      }

      .color-content {
        width: 100%;
        height: 24px;
        background: linear-gradient(90deg, #feefe7 0%, #f56411 100%);
        display: flex;
        align-items: center;
        color: #ffffff;
        justify-content: space-between;
      }

      .color-item {
        width: 10%;
        display: flex;
        flex-flow: column nowrap;

        .color-item-marker {
          width: 100%;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .color-item-text {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #000000;
        }
      }
    }
  }

  .disclaimer {
    font-size: 10px;
    text-align: left;
  }
}

.clear-screen-btn {
  position: absolute;
  top: 8px;
  right: 8px;

  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 12px;
  color: #000000;
  background-color: rgba(255, 255, 255, 0.6);

  z-index: 8;
}
</style>